export const config = {
    appName: "expexe",
    companyName: "expexe",
    year: new Date().getFullYear(),
    
}